import ReactGA from "react-ga";
import gtag from "ga-gtag";
import { useEffect } from "react";
import { useLocation } from "react-router";
// function for tracking google analytics events

export const eventTrack = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

// function for tracking google analytics 4 events

export const eventTrackGA4 = (action, category, label) => {
  gtag("event", action, {
    event_category: category,
    event_label: label,
  });
};

const ScrollToTop = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>;
};

export default ScrollToTop;
